import {
  TypographyCaption,
  TypographyH3,
  TypographyP2Bold,
} from '@heidi/design-system/typography';
import { FormattedMessage } from 'react-intl';

import {
  CLINICIAN_TRIAL_RECAP_TESTIMONIAL_COPY,
  type ClinicianTrialRecapTestimonialVariant,
} from './message';

export type ClinicianTrialRecapTestimonialProps = {
  /** Region/country-resolved testimonial, chosen at the composition point. */
  variant: ClinicianTrialRecapTestimonialVariant;
};

/**
 * Right-hand testimonial panel for the Clinician upgrade modal trial-recap variant
 * (shown when a fake-clinician-trial user has fewer than 7 days remaining).
 *
 * Regional designs:
 * - US: https://www.figma.com/design/MSqFiRMYvicVZlaiWjmFG3/Trials---upgrades?node-id=10053-39054
 * - Canada: https://www.figma.com/design/MSqFiRMYvicVZlaiWjmFG3/Trials---upgrades?node-id=10053-39060
 * - AU (default): https://www.figma.com/design/MSqFiRMYvicVZlaiWjmFG3/Trials---upgrades?node-id=10053-39048
 * - NZ: https://www.figma.com/design/MSqFiRMYvicVZlaiWjmFG3/Trials---upgrades?node-id=10018-36335
 *
 * The panel background and decorative pattern are provided by
 * `HeidiUpgradeBaseModal` via `UpgradeTestimonialBg`; this component only renders
 * the quote and the doctor's identity row centered inside that panel.
 */
export const ClinicianTrialRecapTestimonial = ({
  variant,
}: ClinicianTrialRecapTestimonialProps) => {
  const copy = CLINICIAN_TRIAL_RECAP_TESTIMONIAL_COPY[variant];

  return (
    <div className="flex max-w-[360px] flex-col items-start justify-center gap-6">
      <TypographyH3 className="text-pretty text-text-primary">
        <FormattedMessage {...copy.quote} />
      </TypographyH3>
      <div className="flex flex-col items-start gap-0.5">
        <TypographyP2Bold className="text-text-primary">
          <FormattedMessage {...copy.author} />
        </TypographyP2Bold>
        <TypographyCaption className="text-text-primary">
          <FormattedMessage {...copy.location} />
        </TypographyCaption>
      </div>
    </div>
  );
};
